import { SubmitSingleBillWidgetContent } from './SubmitSingleBillWidgetContent';
import type { SubmitSingleBillWidgetProps } from './useSubmitSingleBillWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const SubmitSingleBillWidget = ({ hooks, data, handlers, status }: SubmitSingleBillWidgetProps) => {
  return (
    <WithStatusHandling
      skeletonHeight={1}
      status={status}
      errorMessage={status === 'error' ? data.message : undefined}
      retry={status === 'error' ? handlers.retry : undefined}
    >
      {status === 'loaded' && <SubmitSingleBillWidgetContent data={data} handlers={handlers} hooks={hooks} />}
    </WithStatusHandling>
  );
};
